export function createOnceAsync<T>() {
  let current: Promise<T> | null = null;

  return {
    reset() {
      current = null;
    },
    run(factory: () => Promise<T>): Promise<T> {
      if (!current) {
        current = factory();
      }
      return current;
    },
    get pending() {
      return current;
    },
  };
}
